module.exports = __webpack_public_path__ + "images/emoji/racehorse.94285c9af37855ae426e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/racehorse.png
// module id = 9B70
// module chunks = 2